<template>
  <el-dialog
    append-to-body
    width="600px"
    title="修改报价"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <div
        style="
          display: flex;
          gap: 10px;
          align-items: center;
          padding-left: 28px;
          margin-bottom: 10px;
        "
      >
        <el-avatar size="large" :src="info.avatar"></el-avatar>
        <div style="flex: 1">
          <div style="margin-bottom: 6px">{{ info.name }}</div>
          <div>{{ info.phone }}</div>
        </div>
      </div>
      <el-form-item label="当前单价" v-if="info.is_days == 1"> 单价￥{{ info.unit_price }}/天 </el-form-item>
      <el-form-item label="当前报价"> 总金额￥{{ info.amount }} </el-form-item>
      <el-form-item prop="amount" label="新的报价">
        <el-input placeholder="请输入内容" v-model="form.data.amount" clearable>
          <template #append>
            元
            <span v-if="info.is_days  == 1">/天</span>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定修改</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
        data: {
          amount: "",
        },
        rules: {
          amount: [{ required: true, message: "必填", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
    },
    reset(done) {
      this.form.data = { amount: "" };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _param = {
            id: this.info.id,
            amount: this.form.data.amount,
          };
          let apiUrl = "/admin/flex_order/updateApply";
          this.$http
            .post(apiUrl, _param)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
